const userAgent = window?.navigator?.userAgent
const connection = window?.navigator?.connection || {}

const isEdge    = /Edge/.test(userAgent)
const isChrome  = /chrome/i.test(userAgent) && !isEdge
const isSafari  = /^((?!chrome|android).)*safari/i.test(userAgent) && !isEdge

const {
  downlink = 'N/A',
  effectiveType = 'N/A',
  rtt = 'N/A'
} = connection

let browser

if (isEdge) {
  browser = 'Edge'
} else if (isChrome) {
  browser = 'Chrome'
} else if (isSafari) {
  browser = 'Safari'
} else {
  browser = 'Browser unknown'
}

export const getBrowserDetails = () => ({
  browser,
  connection: {
    effectiveType,
    downlinkSpeed: downlink,
    roundTripTime: rtt
  }
})
